import React from 'react';
import { Server, Database, BarChart } from 'lucide-react';

/**
 * Компонент для ввода параметров бэкенда и серверной части AR-проекта
 */
const BackendOptionsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  backendComplexities
}) => {
  if (!formData.includeBackend) {
    return (
      <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
        <label className="flex items-center text-sm font-medium text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            name="includeBackend"
            checked={formData.includeBackend}
            onChange={handleInputChange}
            className="form-checkbox mr-2"
          />
          <Server className="w-4 h-4 mr-2 text-indigo-500" />
          <span>
            Требуется серверная часть (бэкенд)
          </span>
        </label>
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-7">
          Выберите, если вам требуется API, база данных, хранение данных, авторизация пользователей и другая серверная функциональность
        </p>
      </div>
    );
  }

  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Server className="w-5 h-5 mr-2 text-purple-500" />
        Серверная часть и бэкенд
      </h3>

      <div className="flex items-center mb-4">
        <label className="flex items-center text-sm font-medium text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            name="includeBackend"
            checked={formData.includeBackend}
            onChange={handleInputChange}
            className="form-checkbox mr-2"
          />
          <span>
            Включить серверную часть
          </span>
        </label>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Сложность бэкенда */}
        <div>
          <label htmlFor="backendComplexity" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Database className="w-4 h-4 mr-2 text-purple-500" />
            Сложность бэкенда
          </label>
          <select
            id="backendComplexity"
            name="backendComplexity"
            value={formData.backendComplexity}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.backendComplexity ? 'input-error' : ''}`}
          >
            {backendComplexities.map((complexity) => (
              <option key={complexity.id} value={complexity.id}>
                {complexity.name} - {complexity.description}
              </option>
            ))}
          </select>
          {errors.backendComplexity && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.backendComplexity}
            </p>
          )}
        </div>

        {/* Дополнительные опции */}
        <div className="space-y-3">
          <label className="flex items-center text-sm text-gray-700 dark:text-gray-300">
            <input
              type="checkbox"
              name="includeCMS"
              checked={formData.includeCMS}
              onChange={handleInputChange}
              className="form-checkbox mr-2"
            />
            <span>
              Система управления контентом (CMS)
            </span>
          </label>
          
          <label className="flex items-center text-sm text-gray-700 dark:text-gray-300">
            <input
              type="checkbox"
              name="includeAnalytics"
              checked={formData.includeAnalytics}
              onChange={handleInputChange}
              className="form-checkbox mr-2"
            />
            <BarChart className="w-4 h-4 mr-2 text-purple-500" />
            <span>
              Аналитика пользовательских данных
            </span>
          </label>
        </div>
      </div>

      <div className="mt-4 bg-purple-100 dark:bg-purple-900/30 p-3 rounded-lg border border-purple-200 dark:border-purple-800">
        <div className="flex items-start">
          <Server className="w-5 h-5 text-purple-600 dark:text-purple-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-purple-700 dark:text-purple-300 mb-1">
              Важно о серверной части для AR
            </h4>
            <p className="text-xs text-purple-600 dark:text-purple-400">
              Бэкенд позволяет добавить в AR-приложение хранение данных, аутентификацию пользователей, 
              управление контентом и аналитику. Облачное хранение 3D-моделей позволяет уменьшить размер 
              приложения и динамически обновлять контент без обновления самого приложения.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackendOptionsSection;